import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';

const BackdropHlsAdjustmentColorizeListItem = (props) => {
    const { updateBackgroundSettings, hlsAdjustmentColorize } = props;
    const onColorizeChange = (event) => updateBackgroundSettings({ hlsAdjustment: { colorize: event.target.checked } });

    return (
        <SwitchListItem
            text='Colorize'
            checked={hlsAdjustmentColorize}
            onChange={onColorizeChange}
        />
    );
};

const mapStateToProps = (state) => {
    const hlsAdjustmentColorize = state.createPreview.present.videoSettings.background.hlsAdjustment.colorize;
    return { hlsAdjustmentColorize }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentColorizeListItem);